module.exports = __webpack_public_path__ + "img/down_icon.267553d.png";